import {
    ICubeSourceDataSource,
    ICubeSourceMetricsPolicy,
    IMetricPolicyOptions,
} from "../../PA.HyperRectangle.Core/CubeSource.IF";
import { ICellMetric } from "../../PA.HyperRectangle.Core/PA.HyperRectangle.IF";
import * as _ from "lodash";
import { WB_SimulationInputRow } from "../../PA.Core/PAdbSchemaRows";
import { PAdbContext } from "../../PA.Core/PAdbContext";
import { esWB_Simulation_Input } from "../../PA.Core/PAdbSchema";
import { SimulatorInputMetric } from "../../PA.Simulation.BusinessObjects/SimulatorInputMetric";

export class SimulationInputMetricPolicy implements ICubeSourceMetricsPolicy {
    get PolicyId(): string {
        return "SimulationInputs";
    }

    async getMetrics(DataSource: ICubeSourceDataSource, options: IMetricPolicyOptions): Promise<ICellMetric[]> {
        if (_.isEmpty(options?.SIMULATION_INPUT_IDs) && _.isEmpty(options?.WB_SIMULATION_INPUT_IDs)) return [];

        let dbContext = new PAdbContext();
        let arrSimInputRows: WB_SimulationInputRow[] = [];
        if (!_.isEmpty(options?.SIMULATION_INPUT_IDs)) {
            arrSimInputRows = <WB_SimulationInputRow[]>(
                await dbContext.findAll(esWB_Simulation_Input, {
                    where: { DELETED_IND: { neq: "1" }, SIMULATION_INPUT_ID: { inq: options.SIMULATION_INPUT_IDs } },
                })
            );
        }
        if (!_.isEmpty(options?.WB_SIMULATION_INPUT_IDs)) {
            arrSimInputRows = <WB_SimulationInputRow[]>(
                await dbContext.findAll(esWB_Simulation_Input, {
                    where: {
                        DELETED_IND: { neq: "1" },
                        WB_SIMULATION_INPUT_ID: { inq: options.WB_SIMULATION_INPUT_IDs },
                    },
                })
            );
        }

        const rv: ICellMetric[] = [];
        _.forEach(arrSimInputRows, (si) => {
            const sm = new SimulatorInputMetric(si, false, DataSource.Alias + "_", { aliasId: DataSource.Alias });
            rv.push(sm);
        });
        return rv;
    }
}
